export default {"src":"/_next/static/media/TheGraph.0cc49c59.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};